import { EventType } from '../../../../../services/Event/types'
import { GeneralFieldsEditor } from '../GeneralFieldsEditor'
import { SeriesForm } from './eventSeriesFormShared'

interface IProps {
  form: SeriesForm
  patchSeries: (patch: Partial<SeriesForm>) => void
  fieldErrors: Record<string, string[]>
  saving: boolean
  eventTypes: EventType[]
  activeCampaignLists: { id: string; name: string }[]
  seriesHelpFormAllowed: boolean
  seriesHelpFormBlockedHint: string
}

export function EngagementTab({
  form,
  patchSeries,
  fieldErrors,
  saving,
  eventTypes,
  activeCampaignLists,
  seriesHelpFormAllowed,
  seriesHelpFormBlockedHint
}: IProps) {
  return (
    <GeneralFieldsEditor
      value={form}
      onChange={patchSeries}
      groups={['testimonial', 'help_form']}
      eventTypes={eventTypes}
      activeCampaignLists={activeCampaignLists}
      formatForLocation={form.format}
      disabled={saving}
      helpFormAllowed={seriesHelpFormAllowed}
      helpFormBlockedHint={seriesHelpFormBlockedHint}
      errors={fieldErrors}
    />
  )
}
